import { useAuth } from '@/lib/auth';
import { Button } from '@/components/ui/button';
import { useNavigate } from 'react-router-dom';
import { AlertOctagon } from 'lucide-react';

export default function WrongDomainPage() {
  const { meta } = useAuth();
  const nav = useNavigate();
  return (
    <div className="min-h-screen flex items-center justify-center p-6">
      <div className="max-w-md w-full border rounded-xl p-8 bg-[hsl(var(--card))]" style={{ borderColor: 'hsl(var(--border))' }} data-testid="wrong-domain-screen">
        <div className="w-10 h-10 rounded-full flex items-center justify-center mb-4" style={{ background: 'hsl(var(--danger-bg))' }}>
          <AlertOctagon size={20} color="hsl(var(--danger))" />
        </div>
        <h2 className="font-heading text-xl font-semibold">This workspace is private.</h2>
        <p className="mt-1 text-[14px] text-[hsl(var(--foreground-muted))]">
          32DECEMBER OS is restricted to <span className="font-mono">@{meta?.allowed_email_domain}</span> accounts. If you believe this is an error, please contact your team lead.
        </p>
        <div className="mt-4 border-t pt-4 flex gap-2" style={{ borderColor: 'hsl(var(--border))' }}>
          <Button variant="outline" onClick={() => nav('/login')} data-testid="wrong-domain-back">Back to sign-in</Button>
        </div>
      </div>
    </div>
  );
}
